import Component from 'components/component';
import ViewCollapse from 'components/view-collapse';
import { formatDuration } from 'helpers/date';
import { DateTime } from 'luxon';
import { DI } from 'modules';
import InfoItem from 'pages/content/components/info-item';
import React from 'react';

function MetaData(props) {
  const { common = {}, entity = {}, isDesktop } = props;
  const { classList } = Component;
  const string = key => common.strings[`page.video.properties.${key}`];

  return (
    <div className={classList('live-targets', isDesktop && '_desktop')}>
      <ViewCollapse title={string('title_panel')}>
        <div className="live-target__list">
          <InfoItem label={string('file_id')} value={entity.id} />
          <InfoItem
            label={string('published')}
            value={DateTime.fromISO(entity.published_at).toFormat(
              common.strings['page.video.date.format']
            )}
          />
          <InfoItem
            label={string('updated')}
            value={DateTime.fromISO(entity.updated_at).toFormat(
              common.strings['page.video.date.format']
            )}
          />
          <InfoItem label={string('format')} value={entity.format} />
          <InfoItem
            label={string('duration')}
            value={formatDuration(entity.duration)}
          />
          <InfoItem label={string('ratio')} value={parseRatio(entity.ratio)} />
          <InfoItem label={string('region')} value={entity.region_name} />
        </div>
      </ViewCollapse>
    </div>
  );
}

function parseRatio(ratio) {
  if (ratio === 'r_16x9') {
    return '16:9';
  } else if (ratio === 'r_4x3') {
    return '4:3';
  }
  return '';
}

export default DI(['common'])(MetaData);
